export enum SettingConsts {
    ServiceOperatorsScheduledDefaultDisplayMode = 'ServiceOperatorsScheduledDefaultDisplayMode', //Setting che contiene il display mode di default delle service operator scheduled
}

export enum ServiceOperatorScheduledDefaultDisplayModeConsts {
    List = 'list',
    FullCalendar = 'fullCalendar',
}
